import React from 'react';

//controls
import AvatarCircle from './AvatarCircle';
//icon
import { Img1,Img2,Img3, Img4, Img5, Img6 } from '../../svg';


const IconProgressBar = ({indexProgress}) => {

    const widthIcon = 30;

    const arrIcons = [
        <Img1 width={widthIcon} className="sg-iconbaritem" indexProgress={indexProgress}/>,
        <Img2 width={widthIcon} className="sg-iconbaritem" indexProgress={indexProgress}/>,
        <Img3 width={widthIcon} className="sg-iconbaritem" indexProgress={indexProgress}/>,
        <Img4 width={widthIcon} className="sg-iconbaritem" indexProgress={indexProgress}/>,
        <Img5 width={widthIcon} className="sg-iconbaritem" indexProgress={indexProgress}/>,
        <Img6 width={widthIcon} className="sg-iconbaritem" indexProgress={indexProgress}/>
    ]

    return (
        <div className="sg-iconbar">
            {arrIcons.map((icon, index) => 
                <AvatarCircle key={index} index={index} indexProgress={indexProgress} width={50}>
                    {icon}
                </AvatarCircle>
            )}
            <div className="sg-statusbar sg-statusbar-muted"></div>
            <div className={`sg-statusbar sg-statusbar-progress line-step-${indexProgress}`}></div>
        </div>
    );
}

export default IconProgressBar;
